var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsignIconPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #003c71;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.1,164.3c-1,0-2-.4-2.7-1.1l-26.2-26.2c-1.5-1.5-1.5-3.9,0-5.4,1.5-1.5,3.9-1.5,5.4,0l26.2,26.2c1.5,1.5,1.5,3.9,0,5.4-.8.8-1.7,1.1-2.7,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.5,152.8l-21.4-21.4c5.2-.3,10.4-2.4,14.3-6.4,1.8-1.8,3.3-3.9,4.3-6.2.9-1.9,0-4.2-1.9-5.1-1.9-.9-4.2,0-5.1,1.9-.7,1.5-1.6,2.8-2.8,4-5.7,5.7-15.1,5.5-21-.4l-4.4-4.4c-.8-.8-1.7-1.1-2.7-1.1-1,0-2,.4-2.7,1.1-1.1,1.1-1.4,2.8-.8,4.2.2.5.5.9.8,1.3l37.9,37.9c.8.8,1.7,1.1,2.7,1.1s2-.4,2.7-1.1c1.5-1.5,1.5-3.9,0-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.4,164.3c-1,0-2-.4-2.7-1.1l-21.7-21.9c-9.6-10.1-11.5-24-4.7-34.7,6.8-10.8,20.3-14.8,34.4-10.1l22.2,7.2c2,.7,3.1,2.8,2.5,4.8-.7,2-2.8,3.1-4.8,2.5l-22.2-7.2c-12.9-4.3-21.7.8-25.5,6.9-4,6.4-4.5,16.7,3.7,25.3l21.7,21.9c1.5,1.5,1.5,3.9,0,5.4-.8.7-1.7,1.1-2.7,1.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.9,51.7c1,0,2,.4,2.7,1.1l26.2,26.2c1.5,1.5,1.5,3.9,0,5.4-1.5,1.5-3.9,1.5-5.4,0l-26.2-26.2c-1.5-1.5-1.5-3.9,0-5.4.8-.8,1.7-1.1,2.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,63.2l21.4,21.4c-5.2.3-10.4,2.4-14.3,6.4-1.8,1.8-3.3,3.9-4.3,6.2-.9,1.9,0,4.2,1.9,5.1,1.9.9,4.2,0,5.1-1.9.7-1.5,1.6-2.8,2.8-4,5.7-5.7,15.1-5.5,21,.4l4.4,4.4c.8.8,1.7,1.1,2.7,1.1,1,0,2-.4,2.7-1.1,1.1-1.1,1.4-2.8.8-4.2-.2-.5-.5-.9-.8-1.3l-37.9-37.9c-.8-.8-1.7-1.1-2.7-1.1s-2,.4-2.7,1.1c-1.5,1.5-1.5,3.9,0,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.6,51.7c1,0,2,.4,2.7,1.1l21.7,21.9c9.6,10.1,11.5,24,4.7,34.7-6.8,10.8-20.3,14.8-34.4,10.1l-22.2-7.2c-2-.7-3.1-2.8-2.5-4.8.7-2,2.8-3.1,4.8-2.5l22.2,7.2c12.9,4.3,21.7-.8,25.5-6.9,4-6.4,4.5-16.7-3.7-25.3l-21.7-21.9c-1.5-1.5-1.5-3.9,0-5.4.8-.7,1.7-1.1,2.7-1.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsignIconPrimary);
export default __webpack_public_path__ + "static/media/asign-icon-primary.8fb46bad3af877074cb73f3588d0c950.svg";
export { ForwardRef as ReactComponent };